import React from 'react';

const CalendarDayHeader: React.FC<CalendarDayHeaderProps> = ({
    day,
    lastInMonth,
    index,
    length,
    style,
}) => {
    const dayArray: string[] = day.split('-');
    const y = dayArray[0];
    const m = dayArray[1];
    const d = dayArray[2];

    const gridRowStart = 'header-day-start';
    const gridColumnStart = index === 0 ? 'sidebar-end' : `start-${y}-${m}-${d}`;
    const gridRowEnd = 'header-day-end';
    const gridColumnEnd = index === length - 1 ? 'cols-end' : `end-${y}-${m}-${d}`;

    const dayHeaderStyles = {
        gridArea: `${gridRowStart} / ${gridColumnStart} / ${gridRowEnd} / ${gridColumnEnd}`,
    };

    return (
        <div
            className={`day-header ${lastInMonth ? 'last-in-month' : ''}`}
            style={{ ...dayHeaderStyles, ...style }}
        >
            {+d}
        </div>
    );
};

interface CalendarDayHeaderProps {
    day: string;
    lastInMonth?: boolean;
    index: number;
    length: number;
    style?: React.CSSProperties;
}

export default CalendarDayHeader;
